import classNames from "classnames";
import { BasketIcon } from "~/common/icons/BasketIcon";

export function BasketEdit(props: {
  size: number;
  basket_color: string;
  basket_bg_color: string;
  scroll_effect: "yes" | "no" | "";
  scroll_visibility: "show" | "hide";
  scroll_offset: number;
}) {
  // if scroll effect and visibility set to show, make the basket partially opqaue
  const isInitiallyHidden =
    props.scroll_effect === "yes" && props.scroll_visibility === "show";

  return (
    <div
      className={classNames(
        "tw:rounded-full tw:cursor-pointer tw:flex tw:justify-center tw:items-center",
        { "tw:opacity-25": isInitiallyHidden },
      )}
      style={{
        backgroundColor: props.basket_bg_color,
        height: `${props.size}px`,
        width: `${props.size}px`,
      }}
    >
      <BasketIcon
        style={{
          color: props.basket_color,
          width: `${props.size / 2}px`,
          height: `${props.size / 2}px`,
        }}
      />
    </div>
  );
}
